import React, { useState } from 'react';

import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import { Link } from 'react-router-dom';
import Slider, { Range } from 'rc-slider';
import { TextField } from '@material-ui/core';
import 'rc-slider/assets/index.css';
import './Blogs.css';

const BlogsList = (props) => {
    const { blogToken } = props;
    return (
        <div className='blog-container'>
            <Navbar />
            <div className='container'>

                <div>
                    <div className="blog-heading">
                        <div className="row">
                            <div className="col s12">
                                <h4>Blogs Listing </h4>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col m4 s12">
                            <div className="left-side-blog-list">
                                <h5>Eight Best Stretches to do before running</h5>
                               <div className="ls-blog">
                                   <div className="awt"><i class="far fa-2x fa-arrow-alt-circle-right"></i> <div class="lsbh">Walking Lunges</div></div>
                                   <div class="content">
                                   <img src='https://st4.depositphotos.com/35063826/38706/i/1600/depositphotos_387066142-stock-photo-young-blonde-girl-green-eyes.jpg' className="left-sideimg" />
                                   <p>Accordind to wikipedia a news article discusses current or recent news of either general interest (i.e. daily newspapers) or of a specific topic (i.e. political or trade news magazines, club newsletters, or technology news websites).</p>
                                   </div>
                               </div>

                               <div className="ls-blog">
                                   <div className="awt"><i class="far fa-2x fa-arrow-alt-circle-right"></i> <div class="lsbh">Kneeling Hip<br/> Flexor Stretch</div></div>
                                   <div class="content">
                                   <img src='https://st4.depositphotos.com/35063826/38706/i/1600/depositphotos_387066142-stock-photo-young-blonde-girl-green-eyes.jpg' className="left-sideimg" />
                                   <p>Accordind to wikipedia a news article discusses current or recent news of either general interest (i.e. daily newspapers) or of a specific topic (i.e. political or trade news magazines, club newsletters, or technology news websites).</p>
                                   </div>
                               </div>

                               <div className="ls-blog">
                                   <div className="awt"><i class="far fa-2x fa-arrow-alt-circle-right"></i> <div class="lsbh">Slide Stretch</div></div>
                                   <div class="content">
                                   <img src='https://st4.depositphotos.com/35063826/38706/i/1600/depositphotos_387066142-stock-photo-young-blonde-girl-green-eyes.jpg' className="left-sideimg" />
                                   <p>Accordind to wikipedia a news article discusses current or recent news of either general interest (i.e. daily newspapers) or of a specific topic (i.e. political or trade news magazines, club newsletters, or technology news websites).</p>
                                   </div>
                               </div>
                            </div>
                        </div>
                        <div className="col m8 s12">
                            <div className="blog-listbg"> </div>
                            <div className="blog-list-content">
                                <h3>BECOME A TRAIL <br/>MONSTER</h3>
                                <div className="author">By Jacob Walker</div>
                                <p>Accordind to wikipedia a news article discusses current or recent news of either general interest (i.e. daily newspapers) or of a specific topic (i.e. political or trade news magazines, club newsletters, or technology news websites).</p>

                                <p>A news article can include accounts of eyewitnesses to the happening event. It can contain photographs, accounts, statistics, graphs, recollections, interviews, polls, debates on the topic, etc. Headlines can be used to focus the reader's attention on a particular (or main) part of the article. The writer can also give facts and detailed information following answers to general questions like who, what, when, where, why and how.</p>
                                <p>Quoted references can also be helpful. References to people can also be made through the written accounts of interviews and debates confirming the factuality of the writer's information and the reliability of his source. The writer can use redirection to ensure that the reader keeps reading the article and to draw her attention to other articles. For example, phrases like "Continued on page 3" redirect the reader to a page where the article is continued.</p>

                                <p>While a good conclusion is an important ingredient for newspaper articles, the immediacy of a deadline environment means that copy editing occasionally takes the form of deleting everything past an arbitrary point in the story corresponding to the dictates of available space on a page. Therefore, newspaper reporters are trained to write in inverted pyramid style, with all the most important information in the first paragraph or two. If the less vital details are pushed towards the end of the story, then the potentially destructive impact of draconian copy editing will be minimized.</p>
                            </div>




                        </div>
                    </div>
                </div>



               

            </div>


            <Footer />
        </div>
    );
};

export default BlogsList;
